<template>
    <div class="order_detial" v-loading="loading">
        <div class="order_titles">查看订单详情</div>
        <div class="order_derial_box">
             
             
            <div class="order_item">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ order_detial.created_at }} </div>
                        <div class="order_no">订单号：{{ order_detial.order_sn }}</div>
                    </div>
                </div>
                <div class="order_info_shop">
                    <div class="shop_list">
                        <div class="shop_item">
                            <div class="shop_left">
                                <div class="shop_img">
                                    <img src="@/assets/img/index/legal/bg1.png" alt="">
                                </div>
                                <div class="shop_title">{{ (order_detial.pro||{}).title }}</div>
                            </div>
                            <div class="shop_right">
                                <div class="shop_price1">{{(order_detial.pro||{}).price}}元</div>
                                <div class="shop_num">X1</div>
                                <div class="shop_price2">{{(order_detial.pro||{}).price}}元</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_price">
                        <div class="btns_lefts">
                            <div class="text1">
                                共
                                <span>1</span>
                                个商品
                            </div>
                            <div class="text2">
                                合计金额
                                <span> {{(order_detial.pro||{}).price}}</span>
                                元
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="pj_box">
                <div class="pj_tops">
                    <div class="texts1">总体评价</div>
                    <div class="pj_nums">
                        <img src="@/assets/img/user_info/user_order/xx_1.png" alt="" v-for="(item,index) in 5" v-if="(index+1)<=nums" @click="handle_nums(index)">
                        <img src="@/assets/img/user_info/user_order/xx_2.png" alt="" v-for="(item,index) in 5" v-if="(index+1)>nums" @click="handle_nums(index)">
                    </div>
                </div>
                <div class="pj_boms">
                    <textarea name="" id="" placeholder="请输入…" v-model="texts" ></textarea>
                </div>
            </div>
            <div class="order_btns">
                <div class="btns1" @click="handle_end">发表评价</div>
              
            </div>
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            tyle_ac: 0,
            order_detial:{},
            texts:'',
            nums:0

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()

    },
    methods: {
        get_detial(){
            this.loading = true
            this.$api("myOrderDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data

                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_nums(index){
            console.log('星星',index+1)
            this.nums=index+1
        },
        handle_end(){
            if(!this.texts){
                alertErr('请输入评价内容')
                return
            }
            this.loading = true
            this.$api("comment", {
                order_id:this.$route.query.id,
                level:this.nums,
                content:this.texts,
			}, "post").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    this.$router.back()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        


    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_derial_box {
        margin-top: 24px;
        padding: 24px;
        background: #FFFFFF;

     

        .order_item {
            // width: 1132px;
            min-height: 260px;
            margin-top: 24px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;

            .item_titles {
                // width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;

                .order_lefts {
                    display: flex;
                    align-items: center;

                    .order_time {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-right: 20px;
                    }

                    .order_no {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    }
                }

                .order_rights {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }

            .order_info_shop {
                padding: 0 24px;
                padding-top: 24px;

                .shop_list {

                    border-bottom: 1px solid #E5E5E5;

                    .shop_item {
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .shop_left {
                            display: flex;
                            align-items: center;

                            .shop_img {
                                width: 104px;
                                height: 104px;

                                img {
                                    width: 104px;
                                    height: 104px;
                                }
                            }

                            .shop_title {
                                padding-left: 24px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }
                        }

                        .shop_right {
                            display: flex;
                            align-items: center;

                            .shop_price1 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;

                            }

                            .shop_num {
                                width: 100px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }

                            .shop_price2 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;


                            }
                        }
                    }
                }

                .order_price {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    height: 64px;

                    .btns_lefts {
                        display: flex;
                        align-items: center;

                        .text1 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;

                            span {
                                color: #377CFD;
                                font-weight: bold;
                            }
                        }

                        .text2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            margin-left: 20px;
                            span {
                                color: #377CFD;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
        .pj_box{
            width: 1132px;
            height: 192px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;
            margin-top: 24px;
            .pj_tops{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                padding: 0 24px;
                display: flex;
                align-items: center;
                .texts1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;

                }
                .pj_nums{
                    padding-left: 20px;
                    img{
                        width: 21px;
                        margin-right: 16px;
                        cursor: pointer;
                    }
                }

            }
            .pj_boms{
                padding: 16px 24px;
                textarea{
                    width: 100%;
                    height: 120px;
                }
            }
        }
        .order_btns{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 32px;
            .btns1{
                width: 320px;
                height: 48px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 48px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
            }
          
        }

    }



}
</style>